import {
  type FC,
  type PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { UserMediaContext } from './context';
import { stopStream, startStream } from './stream';

export const UserMediaProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [stream, setStream] = useState<MediaStream | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);

  const startMediaStream = useCallback(async () => {
    let canceled = false;
    const currentPromise = startStream()
      .then((mediaStream) => {
        if (!canceled) {
          setStream(mediaStream);
          setError(undefined);
        }
        return mediaStream;
      })
      .catch((err: Error) => {
        if (!canceled) {
          setStream(undefined);
          setError(err);
        }
        return undefined;
      });

    return () => {
      canceled = true;
      currentPromise.then(stopStream);
    };
  }, []);

  const askPermission = useCallback(() => {
    startMediaStream();
    setError(undefined);
  }, [startMediaStream, setError]);

  useEffect(() => {
    startMediaStream();
  }, [startMediaStream]);

  useEffect(() => {
    return () => {
      stopStream(stream);
    };
  }, [stream]);

  const value = {
    stream,
    error,
    askPermission,
  };

  return (
    <UserMediaContext.Provider value={value}>
      {children}
    </UserMediaContext.Provider>
  );
};
